
import bestOffer from "./bestOffer.vue"
import wareCard from "./wareCard.vue"
import { getWareItems } from "@/components/cart/js/common"

export default {
  name: "InvalidProducts",
  components: {
    bestOffer,
    wareCard
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isShow: true
    }
  },
  methods: {
    getWareItems,
    toggleShow() {
      this.isShow = !this.isShow
    }
  }
}
